import { httpCreate } from './http';

const http = httpCreate('/srv/live-watermark');

export const liveWatermark = {
	// 获取直播间水印信息
	getWaterMarkList(actitivtyId, params) {
		return http.get(`${actitivtyId}/list`, { params });
	},
	getWaterMarkInfo(params) {
		return http.get('/list', { params });
	},
	// 直播间水印信息保存
	saveWaterMarkInfo(activityId, params) {
		return http.post(`/${activityId}`, params);
	},
	// 水印开启
	open(watermarkBindId) {
		return http.post(`/bind/open/${watermarkBindId}`);
	},
	// 水印关闭
	close(watermarkBindId) {
		return http.post(`/bind/close/${watermarkBindId}`);
	},
	// 编辑水印信息
	editorWaterMarkInfo(watermarkId, params) {
		return http.put(`/${watermarkId}`, params);
	},
	// 删除直播间水印
	deleteWaterMarkInfo(watermarkBindId) {
		return http.delete(`/bind/delete/${watermarkBindId}`);
	},
	// 获取直播间水印的绑定id
	getBindList(watermarkId, params) {
		return http.post(`/bind/${watermarkId}/list`, {}, { params });
	},
};
